module.exports = __webpack_public_path__ + "img/1525660844.629c6d97.jpg";